import { SHARE_NAV_SWITCH } from "../constant";

export const sharedSwithPortalNav = (switchObj: boolean) => ({
  type: SHARE_NAV_SWITCH,
  data: switchObj,
});
